import es from 'vuetify/es5/locale/es'

export default {
  label: 'Español',
  //page login
  login: 'Login',
  register: 'Register',
  username: 'Username',
  password: 'Password',
  login_account: 'Login accoount',
  //app drawer
  sponsor: 'Sponsor',
  // menu
  menu: {
    home: 'Home',
    dashboard: 'Dashboard',
    companies: 'Companies',
    dealers: 'Dealers',
    agents: 'Agents',
    clients: 'Clients',
    locations: 'Locations',
    'my locations': 'My Locations',
    'air sources': 'Air Sources',
    technicians: 'Technicians',
    users: 'Users',
    'user approval': 'User Approval',
    billing: 'Billing',
    'my company': 'My Company',
    units: 'Units',
    lols: 'LOLs',
    calibrations: 'Calibrations',
    'certificate review': 'Certificate Review',
    certificates: 'Certificates',
    standards: 'Standards',
    schedule: 'Schedule',
    feedback: 'Feedback',
    reports: 'Reports',
    support: 'Support',
    training: 'Training',
    supplies: 'Supplies',
    'access denied': 'Access Denied',

    media: 'Media',
    task: 'Task',
    CMS: 'CMS',
    widget: 'Widget',
    chart: 'Chart',
    list: 'List',
    social: 'Social',
    statistic: 'Statistic',
    echart: 'Echart',
    g2: 'G2',
    mail: 'Mail',
    inbox: 'Inbox',
    table: 'Table',
    access_denied: 'Access Deny',
    basic_form: 'Basic Form',
    step_form: 'Wizard Form',
    form: 'Form',
    acl: 'ACL',
    user_list: 'User List',
    edit_user: 'Edit User',
    create_user: 'Create User',
    changelog: 'Changelog',
    calendar: 'Calendar',
    all: 'All'
  },
  //media
  media: 'Media',
  // rules
  rule: {
    required: '{0} is required'
  },

  //error

  ...es
}
